import { HeaderMenuDropdownProps } from "../interfaces";

interface ICalclulateSubmenuHeightConfiguration {
	sections: HeaderMenuDropdownProps["sections"];
}

const calculateSubmenuHeight = (configuration: ICalclulateSubmenuHeightConfiguration, isShowingDescription = false) => {
	const SPACE_BETWEEN = 9;
	const TOTAL_ITEM_MARGIN = 32;
	const TOTAL_PADDING = 64;

	let ITEM_HEIGHT = 20;
	if (isShowingDescription) {
		ITEM_HEIGHT = ITEM_HEIGHT * 2;
	}

	let maxHeight = 0;

	for (const section of configuration.sections) {
		const totalItems = section.menuItemGroups.reduce((acc, group) => acc + group.menuItems.length, 0);
		const totalGroups = section.menuItemGroups.length;

		const totalSpacing = (totalGroups - 1) * SPACE_BETWEEN;
		const totalMargin = totalItems * TOTAL_ITEM_MARGIN - TOTAL_ITEM_MARGIN / 4;

		const sectionHeight = totalItems * ITEM_HEIGHT + totalSpacing + totalMargin + TOTAL_PADDING;
		if (sectionHeight > maxHeight) {
			maxHeight = sectionHeight;
		}
	}

	return maxHeight;
};

export default calculateSubmenuHeight;
